import React, { useEffect, useRef } from "react";
import style from "./EuleriagymMonodimensionalBalanceChart.module.sass";
import { monodimensionalChart } from "../euleriagymBalanceCharts";

function EuleriagymMonodimensionalBalanceChart(props) {
  const {
    colors,
    clampedData,
    data,
    directions,
    enableLeft,
    enableRight,
    labels,
    title
  } = props

  const canvasContainer = useRef(null)
  const chartInstance = useRef(null)

  useEffect(() => {
    renderChart()
  }, [clampedData, labels])

  useEffect(() => {
    updateChartColors()
  }, [enableLeft, enableRight])

  const getDatasets = (samples) => {
    return samples.map((item, index) => {
      return {
        data: item,
        label: labels[index],
        borderColor: colors[index],
        backgroundColor: colors[index],
      }
    })
  }

  const renderChart = () => {
    if(canvasContainer.current) {
      let canvas = canvasContainer.current.querySelector("canvas");
      if(canvas) {
        canvas.remove();
      }
      canvas = document.createElement("canvas");
      canvasContainer.current.appendChild(canvas);

      const datasets = getDatasets(clampedData)
      const tooltipDatasets = getDatasets(data)

      chartInstance.current = monodimensionalChart(canvas, datasets, labels, tooltipDatasets)
    }
  }

  const updateChartColors = () => {
    if(chartInstance.current && enableLeft != null && enableRight != null) {
      chartInstance.current.data.datasets.map((dataset, index) => {
        if (index == 0) {
          dataset.borderColor = enableLeft ? colors[index]: "rgba(255, 164, 17, 0.2)";
          dataset.backgroundColor = dataset.borderColor;
        } else {
          dataset.borderColor = enableRight ? colors[index] : "rgba(167, 120, 255, 0.2)";
          dataset.backgroundColor = dataset.borderColor;
        }
      })
      chartInstance.current.update()
    }
  }

  return (
    <div className={style.chartWrapper}>
      <div className={style.chartTitle}>{title}</div>
      <div className={style.chartRow}>
        <div className={style.xUnit}>{'[s]'}</div>
        <div className={style.yUnit}>{'[cm]'}</div>
        <div ref={canvasContainer} className={style.canvasWrapper}>
        </div>
        <div className={style.labels}>
          {directions.map((direction, index) => {
            return (
              <div key={index} className={style.label}>
                {direction}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default EuleriagymMonodimensionalBalanceChart;